module.exports = __webpack_public_path__ + "img/delete-cropper.e1a04a53.svg";